<template>
  <mp-flex justify="space-between" align-items="center" padding-x="6" padding-y="3" gap="4">
    <mp-box v-if="breadcrumbs.length > 0" min-h="12">
      <breadcrumb :values="breadcrumbs" />
      <mp-flex align-items="center" gap="2">
        <mp-heading as="h1" font-size="2xl" font-weight="bold" data-qa="page-header-title">{{ title }}</mp-heading>
        <slot name="tag" />
      </mp-flex>
    </mp-box>
    <mp-flex v-else min-h="12" align-items="center" gap="2">
      <mp-heading as="h1" font-size="2xl" font-weight="bold" data-qa="page-header-title">
        {{ title }}
      </mp-heading>
      <slot name="tag" />
    </mp-flex>
    <slot name="action" />
  </mp-flex>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';

export default {
  name: 'PageHeader',
  components: { Breadcrumb },
  props: {
    breadcrumbs: {
      type: Array,
      default() {
        return [];
      },
    },
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="sass" scoped></style>
